import React from 'react';
import { t } from 'i18next';
import {ProfileHeaderContent, UserNameProps} from "templates"
import { toSentancePascalCase } from 'common';



function UserName({ firstName, lastName }: Readonly<UserNameProps>) {
  return (
    <div className='mb-2 mb-md-0 mb-lg-0' data-testid="username_component">
      <ProfileHeaderContent
        header={t('profile.name')}
        contentOne={toSentancePascalCase(`${firstName} ${lastName}`.trim())}
        dataTestIdOne="profileName"
        contentClassNameOne='mb-0' 
        disabledText={true}
      />
    </div>
  );
}

export default UserName;
